<template>
  <div class="single-choice">
    <el-radio-group v-model="issue.select" class="w-full">
      <div class="items-group mb-4 last:mb-0" v-for="(group, index) in issue.item_groups" :key="index">
        <div class="cg-title text-base mb-2">
          <span> {{ group.title }}</span>
        </div>
        <ul class="cg-content" :style="gridStyle">
          <li v-for="item in group.options" :key="item.id" class="mb-2 last:mb-0">
            <single-choice-item
              :item="item"
              :class="issue.getChoiceCheckedClass(item.id,question)"
              :selected="issue.select === item.id"
              @click="issue.select = item.id"
              :correct-answer-list="correctAnswerList"
              :question-id="question.id"
              :question-type="question.questionType"
              :enable-relation="item.setting.enableRelation"
            >
              <template v-slot:vote>
                <vote-progress
                    v-if="showVoteProgress && changeExpr"
                    :vote="question.vote"
                    :label="item.id"
                    :checked="issue.select === item.id"
                    :selected="!!issue.select"
                />
              </template>
            </single-choice-item>
          </li>
        </ul>
      </div>
    </el-radio-group>
  </div>
</template>

<script>
import SingleChoiceItem from '@/questions/components/SingleChoiceItem'
import VoteProgress from '@/questions/components/VoteProgress.vue'

export default {
  name: 'SingleChoice',
  components: { VoteProgress, SingleChoiceItem },
  changeExpr: 'changeExpr',
  computed: {
    changeExpr() {
      let item = this.issue.getItemById(this.issue.select)
      if (item) {
        return item.id + item.value + item.content.fileList.length
      } else {
        return ''
      }
    },
    correctAnswerList() {
      if (!this.view) return []
      return this.question.getCorrectAnswerList()
    },
    gridStyle() {
      if (this.issue.choice_num_per_row < 2) {
        return ''
      } else {
        return `
          display:grid;
          grid-template-columns:repeat(${this.issue.choice_num_per_row}, 1fr);
          grid-column-gap: 20px;
        `
      }
    }
  }
}
</script>
